import { Lock } from 'lucide-react';

import EmptyState from '@/components/ui/empty-state';

export const RestrictedView = () => (
  <EmptyState
    title="Captain-Only Access"
    description="This section is restricted to the team captain. Contact your captain to make changes here."
    icon={<Lock className="h-6 w-6 text-muted-foreground" />}
  />
);
